import {getNumberValidator} from 'konva/lib/Validators'

export const validateNumber = getNumberValidator()

